module.exports = __webpack_public_path__ + "img/2.11215c84.jpg";